import {useEffect,useState} from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import { Card4 } from '../../../../../_metronic/partials/content/cards/Card4'
import Swal from 'sweetalert2'
import { useAuth } from '../../../auth'
import { useAppSelector } from '../../../../../redux/hooks'
import { getsuscriptions, getsuscriptionsglobal,getDeviceId,getDeviceIdtenant } from '../request/request'
import { DemoModal } from '../../../../Modal_Demo/ViewModalDemo'
const API_URL = process.env.REACT_APP_API_URL


type sus={
  id:number
  purchaseOrden:string
  tenantId:number
}
type Device=
  {
    description:string
  }

type ID = undefined | null | number



const CreateDevice = ( props:any ) => {
  /*********************************Constantes**************************************** */
  const tenant= useAppSelector(state =>state.TenantSlice.id)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const [ ID , setID]=useState<ID>(undefined)

  const Type = useAppSelector(state => state.CloudSlice.Type)

  const{currentUser}= useAuth()

  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)

  ////
  const [Nombre,setNombre] = useState('');
  const [Description,setDescription] = useState('');
  const [UUid,setUUid] = useState('');
  const [License,setLicense]=useState('');
  const [paymentOption, setPaymentOption] = useState('');
  const [InfoLicense,setInfoLicenece]= useState<Device>({
    description:""
  })


  
  

  /************************************llamadas a la API ********************************************** */

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])
  
    /**********************SE OBTIENEN LAS Suscripciones **********************/

    const[suscripcion, setsuscripcion]=useState<sus[]>([])

    useEffect( () => {
      
      if(tenant ===0 ){
         getsuscriptions().then(response=>{
             setsuscripcion(response.data)
         })
      }
      else if(tenant !==0 ){
         getsuscriptionsglobal(tenant).then(response=>{
             setsuscripcion(response.data)
         })
      }
     
     }, [Id])

     const [susSelect,setsusselect]=useState<any>()
 
     const cambiarstate = (e:any)=>{
         setsusselect(e.target.value)
       }


  /************************************************************************* */
  useEffect(() => {
    const fetchData = async () => {
      try {
        if( props.id !== "" && props.id !==null ){
          if (currentUser?.ListPermiso?.includes('CTXR.Update')){
            if(tenant===0 &&Type!=='Global'){
              const UserResponse = await getDeviceId(Id,props.id);
              setInfoLicenece(UserResponse.data);            
            }
            else if(tenant!==0 &&Type!=='Global'){
              const UserResponse = await getDeviceIdtenant(Id,props.id,tenant);
              setInfoLicenece(UserResponse.data);             
            }
            if(tenant===0 &&Type==='Global'){
              const UserResponse = await getDeviceId(-1,props.id);
              setInfoLicenece(UserResponse.data);              
            }
            else if(tenant!==0&&Type==='Global'){
              const UserResponse = await getDeviceIdtenant(-1,props.id,tenant);
              setInfoLicenece(UserResponse.data);             
            }
          }
      }
      } catch (error) {
        console.error('Error al obtener los permisos', error);
      }
       };
  
      fetchData();
  }, [props.id])
/******************************************************************* */
    //const navigate = useNavigate();

    const handleSubmit =async (e:any) => {
    e.preventDefault();

    try{

      if(props.id ===null){
        const body ={
          name:Nombre,
          description:Description,
          uuid:UUid
        }
        if(tenant===0){
        await axios.post(API_URL+'/v1/ctxr/'+susSelect+'/claim', body)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Your device has created',
          showConfirmButton: false,
          timer: 1500
        
        })
        window.location.reload();

      });
      }
      else{
        await axios.post(API_URL+'/v1/ctxr/'+susSelect+'/claim?tenantId='+tenant, body)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Your Device has created',
          showConfirmButton: false,
          timer: 1500
        })
        window.location.reload();
      });
      }
      //navigate('/support/SeeRequest')
    }
    else{
      const actualizar={
        description:InfoLicense.description
      }
     if (tenant===0 && Type!=='Global'){ 
        await axios.put(API_URL+'/v1/ctxr/'+Id+'/'+props.id,actualizar)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Your Device has Update',
          showConfirmButton: false,
          timer: 1500
        })
        props.setID(undefined);
        axios.get(API_URL+'/v1/ctxr/'+Id+'/list')
        .then(res=>{
        props.setRecords(res.data)
        })
        //window.location.reload();
      });
      }
      else if (tenant===0 &&Type==='Global'){ 
        await axios.put(API_URL+'/v1/ctxr/'+-1+'/'+props.id, actualizar)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Your Device has Update',
          showConfirmButton: false,
          timer: 1500
        })
        props.setID(undefined);
        axios.get(API_URL+'/v1/ctxr/'+-1+'/list')
        .then(res=>{
        props.setRecords(res.data)
        })
        //window.location.reload();
      });
      }
      else if (tenant!==0 && Type!=='Global'){
        await axios.put(API_URL+'/v1/ctxr/'+Id+'/'+props.id+'?tenantId='+tenant, actualizar)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Your Device has Update',
          showConfirmButton: false,
          timer: 1500
        })
        props.setID(undefined);
        axios.get(API_URL+'/v1/ctxr/'+Id+'/list?tenantId='+tenant)
          .then(res=>{
          props.setRecords(res.data)
        })
        //window.location.reload();
      });
      }
      else if (tenant!==0 && Type==='Global'){
        await axios.put(API_URL+'/v1/ctxr/'+-1+'/'+props.id+'?tenantId='+tenant, actualizar)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Your Device has Update',
          showConfirmButton: false,
          timer: 1500
        })
        props.setID(undefined);
        axios.get(API_URL+'/v1/ctxr/'+-1+'/list?tenantId='+tenant)
          .then(res=>{
          props.setRecords(res.data)
        })
        //window.location.reload();
      });
      }
    
    }
  }
    catch(error:any){
      console.log(error)

    }

    
   }

  

  ///////////////////////////////////////////////

  const handleOptionChange = (option: string) => {
    setPaymentOption(option);
  };
    



   

  return (
    
    <>
      {props.id === null &&
      <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                                {/* begin::Heading */}
                               {/* <Card4
                                icon='/media/svg/files/NubeTD.svg'
                                title=' '
      description=''></Card4>*/}
                                <div className='text-center mb-5'>
                                <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'>Add device</h1>
                                </div>
                                {/* begin::Heading */}

                        
                                {/* begin::Login options */}

                                <div className='mb-2 bg-light-info p-8 rounded f-parrafo'>
                                    <div className='text-info'>
                                        Use this section to  <strong>Add Devices.</strong> 
                                    </div>
                                </div>

                                
                                <div className='text-center'>
                                <label  className='form-label fs-6 fw-bolder text-dark required form-label f-parrafo ' >CTX-R Name</label>
                                </div>
                                <div className='d-flex flex-center text-center'>
                                <select className=" form-select text-center w-200px border-gray-300 f-parrafo" aria-label="Select example"
                                    onChange={cambiarstate} value={susSelect}>
                                        {suscripcion.length ===0 &&<option disabled selected hidden>No data</option>}
                                        <option  hidden defaultValue={0}>Select a Suscription </option>
                                        { suscripcion.map( (ins:any,x:any) =>
                                          <option key={x} value={ins.id}>{ins.purchaseOrden}</option>
                                          )
                                        }
                                      
                                  </select>
                                </div>
                                <br />
                               
                                {/* Campos solicitud */}
                                <div>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="name">CTX-R Name</label>
                                   <input type="text" 
                                   name='name' 
                                   className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   id='Nombre'
                                   value={Nombre}
                                   onChange={(e:any) => setNombre(e.target.value)}
                                   />
                                </div>
                                <div>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="descripcion">Description</label>
                                   <input type="text" 
                                   name='name' 
                                   className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   id='descripcion'
                                   value={Description}
                                   onChange={(e:any) => setDescription(e.target.value)}
                                   />
                                </div>
                                <br />
                                <p className='text-center fw-bolder f-parrafo'>Select Your Licensing Method</p>

                                <div className="fv-row mb-3">
                                  <div className="form-check form-check-custom form-check-solid">
                                       <input
                                        className='form-check-input border border-azul'
                                        type='radio'
                                        checked={paymentOption === 'payAsYouGo'}
                                        onChange={() => handleOptionChange('payAsYouGo')}
                                        id='payAsYouGo'
                                      />
                                      <label className="form-check-label text-marino f-parrafo fw-bolder" >
                                        Pay As You Go
                                      </label>
                                  </div>
                                </div>

                                <div>
                                   <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0' htmlFor="uuid" 
                                  hidden={paymentOption !== 'payAsYouGo'}>UUID</label>
                                   <input type="text" 
                                   name='uuid' 
                                   hidden={paymentOption !== 'payAsYouGo'}
                                   className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   id='uuid'
                                   value={UUid}
                                   onChange={(e:any) => setUUid(e.target.value)}
                                   />
                                </div>
                                <br />

                                <div className="fv-row mb-3">
                                  <div className="form-check form-check-custom form-check-solid">
                                      <input
                                        className='form-check-input border border-azul'
                                        type='radio'
                                        checked={paymentOption === 'license'}
                                        onChange={() => handleOptionChange('license')}
                                        id='licenseOption'
                                      />
                                      <label className="form-check-label text-marino f-parrafo fw-bolder" >
                                        License
                                      </label>
                                  </div>
                                </div>

                                <div>
                                   <label className='form-label fw-bolder text-marino f-parrafo fs-6 mb-0 ' htmlFor="license" 
                                   hidden={paymentOption !== 'license'}>License</label>
                                   <input type="text" 
                                   name='license' 
                                   hidden={paymentOption !== 'license'}
                                   className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   id='license'
                                   value={License}
                                   onChange={(e:any) => setLicense(e.target.value)}
                                   />
                                </div>
                                <br />
                               
                               
                                      {/* end::Label */}
                                    {/* end::Radio */}

                                {/* begin::Action */}
                               { currentUser?.is_demo!==true&&<div className='d-grid mb-10 justify-content-center'>
                                  <div className='row'>
                                    <div className='col'>
                                        <button
                                        type='submit'
                                        id='kt_sign_in_submit'
                                        className='btn btn-primary'
                                
                                        
                                      >
                                        {!loading && <span className='indicator-label'>Save</span>}
                                        {loading && (
                                          <span className='indicator-progress' style={{display: 'block'}}>
                                          Please wait...
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                          </span>
                                        )}
                                      </button>

                                    </div>
                                    <div className='col'>
                                      <button
                                      className='btn-cancel btn border border-pink text-pink f-parrafo'
                                      style={{width:'200px'}}
                                      onClick={() => props.setID(undefined)}

                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                 
                                </div>}
                                {/* end::Action */}

                            </form>
                            {currentUser?.is_demo===true&& <div className="d-flex justify-content-center">
                                <button  onClick={()=>setID(null)} type='submit' id='kt_sign_in_submit'
                                    >Add</button> 
                                </div>}
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }

      {props.id !==null &&
      <div>
        <div
          className='modal fade show d-block'
          id='kt_modal_add_user'
          role='dialog'
          tabIndex={-1}
          aria-modal='true'
        >
          {/* begin::Modal dialog */}
          <div className='modal-dialog modal-dialog-centered mw-650px'>
            {/* begin::Modal content */}
            <div className='modal-content'>
              <ViewModalHeader setID={props.setID} />
              {/* begin::Modal body */}
              <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                                  {/* begin::Heading */}
                                  <div className='text-center mb-5'>
                                  <h1 className='text-dark fw-bolder mb-3 f-titulo fs-md'>Edit Instance</h1>                                 
                                  </div>
                                  {/* begin::Heading */}
                                  {/* Campos solicitud */}
                                  <div className='f-parrafo'>
                                    <label className='form-label fw-bolder text-dark fs-6 mb-0' htmlFor="name">Description</label>
                                    <input type="text" name='name' value={InfoLicense.description}className='form-control form-control-solid border-primary border-active' 
                                    onChange={(e:any) => setInfoLicenece({...InfoLicense,description: e.target.value})}
                                    />
                                  </div> 

                                  <br />

                                  {/* begin::Action */}
                                  <div className='d-flex flex-center d-grid mb-10'>
                                    
                                    <button
                                      type='submit'
                                      id='kt_sign_in_submit'
                                      className='btn btn-primary'
                              
                                      
                                    >
                                      {!loading && <span className='indicator-label'>Save</span>}
                                      {loading && (
                                        <span className='indicator-progress' style={{display: 'block'}}>
                                        Please wait...
                                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                        </span>
                                      )}
                                    </button>
                                  </div>
                                  {/* end::Action */}
                                  
                                  
                              </form>
                              
              </div>
              {/* end::Modal body */}
            </div>
            {/* end::Modal content */}
          </div>
          {/* end::Modal dialog */}
        </div>
        {/* begin::Modal Backdrop */}
        <div className='modal-backdrop fade show'></div>
        {/* end::Modal Backdrop */}
        </div>
        }   
      {ID !== undefined && <DemoModal setID={setID} id={ID} />}
    </>
  )
}
export {CreateDevice}